// D:\project_Dustre\DustreFront\src\pages\ClientPanel\Products\index.tsx

import React, { useState, useEffect, useCallback, useRef } from 'react'; // Importa useRef
import NewProductModal from './ProductsModal/NewProductModal';
import ProductPreviewModal from './ProductsPreview/ProductPreviewModal';

import ProductsFilterModal, { FilterStatus } from './filterproduct';


import {
  PageContainer,
  Header,
  Title,
  ButtonGroup,
  FilterButton,
  NewProductButton,
  TableHeaderContainer,
  TableWrapper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Actions,
  ActionButton,
  LoadMoreButton
} from './style';

// ATENÇÃO: Estes caminhos de ícones ( '../../../assets/produtcss/' ) dependem
// que a pasta 'produtcss' esteja dentro de 'src/assets/'
import SearchIcon from '../../../assets/produtcss/search-in.svg';
import FilterIcon from '../../../assets/produtcss/filter.svg';
import SwitchOnIcon from '../../../assets/produtcss/Switch.svg';
import SwitchOffIcon from '../../../assets/produtcss/Switch not.svg';
import plusOn from '../../../assets/produtcss/Plus.svg';
import ArrowDownIcon from '../../../assets/produtcss/seta.svg';

type ProductPayloadType = {
  id?: number;
  name: string;
  family: string;
  type: string; // <--- CUIDADO: Este tipo ainda é 'type', não 'groupName'
  colors: string[];
  size: number[];
  price: number;
  status: boolean;
};

type ProductType = {
  id: number;
  code: string;
  name: string;
  family: string;
  type: string;
  colors: string;
  graduation: string;
  price?: string;
  status?: boolean;
  groupId?: number | null;
  group?: {
    id: number;
    name?: string;
    familyId?: number | null;
    family?: {
      id: number;
      name: string;
      colors?: { id: number; name: string; hexCode?: string }[];
    };
  };
};

const ProductsPage = () => {
  const [allProducts, setAllProducts] = useState<ProductType[]>([]);
  const [visibleProducts, setVisibleProducts] = useState<ProductType[]>([]);

  const [checkedProducts, setCheckedProducts] = useState<{ [key: number]: boolean }>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productToEdit, setProductToEdit] = useState<any | null>(null);
  const [previewProduct, setPreviewProduct] = useState<ProductType | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [pageSize] = useState(8);
  const [hasMore, setHasMore] = useState(true);

  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [currentProductFilterStatus, setCurrentProductFilterStatus] = useState<FilterStatus>('all');

  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const [filterButtonPosition, setFilterButtonPosition] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    if (isFilterModalOpen && filterButtonRef.current) {
      const rect = filterButtonRef.current.getBoundingClientRect();
      setFilterButtonPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width
      });
    }
  }, [isFilterModalOpen]);

  const formatProductData = (productBackend: any): ProductType => {
    const familyName = productBackend.group?.family?.name || 'N/A';
    const groupName = productBackend.group?.name || 'N/A';

    const formattedColors = productBackend.group?.family?.colors
      ?.map((color: { name: string }) => color.name)
      .join('; ') || 'N/A';

    const formattedGraduation = Array.isArray(productBackend.size)
      ? productBackend.size.join(', ')
      : 'N/A';
    const formattedPrice = productBackend.price
      ? `R$ ${productBackend.price.toFixed(2).replace('.', ',')}`
      : 'R$ 0,00';

    return {
      id: productBackend.id,
      code: String(productBackend.id),
      name: productBackend.name,
      family: familyName,
      type: groupName,
      colors: formattedColors,
      graduation: formattedGraduation,
      price: formattedPrice,
      status: productBackend.status !== undefined ? productBackend.status : true,
      groupId: productBackend.groupId,
      group: productBackend.group,
    };
  };

  const fetchProducts = useCallback(async (currentPage: number, currentSize: number, statusFilter: FilterStatus) => {
    try {
      let url = `http://localhost:8080/fashion-product/paginated?page=${currentPage}&size=${currentSize}`;

      if (statusFilter === 'active') {
        url += '&status=true';
      } else if (statusFilter === 'inactive') {
        url += '&status=false';
      }

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Erro HTTP! Status: ${response.status}`);
      }

      const rawData = await response.json();
      const productsFromBackend = rawData.content;

      const formattedProducts: ProductType[] = productsFromBackend.map(formatProductData);
      console.log("Produtos recebidos e formatados:", formattedProducts);

      if (currentPage === 0) {
        setAllProducts(formattedProducts);
      } else {
        setAllProducts(prev => [...prev, ...formattedProducts]);
      }

      setHasMore(!rawData.last);

      const initialChecked = formattedProducts.reduce((acc, product) => {
        if (product.id !== undefined) {
          acc[product.id] = product.status || false;
        }
        return acc;
      }, {} as { [key: number]: boolean });
      setCheckedProducts(prev => ({ ...prev, ...initialChecked }));

    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      setHasMore(false);
    }
  }, []);

  useEffect(() => {
    setAllProducts([]);
    setHasMore(true);
    setPage(0);
    fetchProducts(0, pageSize, currentProductFilterStatus);
  }, [currentProductFilterStatus, pageSize, fetchProducts]);


  useEffect(() => {
    if (page > 0 && hasMore && currentProductFilterStatus === 'all') {
      fetchProducts(page, pageSize, currentProductFilterStatus);
    }
  }, [page, fetchProducts, hasMore, currentProductFilterStatus, pageSize]);

  useEffect(() => {
    let filtered = allProducts;
    if (currentProductFilterStatus === 'active') {
      filtered = allProducts.filter(product => product.status === true);
    } else if (currentProductFilterStatus === 'inactive') {
      filtered = allProducts.filter(product => product.status === false);
    }
    setVisibleProducts(filtered);
  }, [allProducts, currentProductFilterStatus]);


  const handleLoadMore = () => {
    if (hasMore && currentProductFilterStatus === 'all') {
      setPage(prevPage => prevPage + 1);
    }
  };

  const updateProductStatus = async (productId: number, newStatus: boolean) => {
    try {
      const url = `http://localhost:8080/fashion-product/${productId}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro ao atualizar status do produto ${productId}! Status: ${response.status}`);
      }

      console.log(`Status do produto ${productId} atualizado para ${newStatus} com sucesso!`);

      // Refetch completo para garantir dados consistentes após a atualização
      setPage(0);
      setAllProducts([]);
      setHasMore(true);
      fetchProducts(0, pageSize, currentProductFilterStatus);

    } catch (error: any) {
      console.error("Erro ao atualizar status do produto:", error.message);
      alert(`Erro ao atualizar status do produto: ${error.message}`);
    }
  };

  const statusCheck = async (productId: number) => {
    const currentStatus = checkedProducts[productId];
    const newStatus = !currentStatus;

    // Atualiza o estado local imediatamente para feedback visual
    setCheckedProducts((prev) => ({
      ...prev,
      [productId]: newStatus,
    }));

    await updateProductStatus(productId, newStatus);
  };

  const handleEdit = (product: ProductType) => {
    const colorsArray = product.colors.split(';').map((c) => c.trim());
    const gradValuesArray = product.graduation
      .split(',')
      .map((v) => Number(v.trim()))
      .filter((n) => !isNaN(n));

    const formattedPriceForModal = product.price || '';

    setProductToEdit({
      id: product.id,
      code: product.code,
      name: product.name,
      family: product.family,
      type: product.type, // <--- AQUI: 'type' novamente
      colors: colorsArray,
      gradValues: gradValuesArray,
      pricing: formattedPriceForModal,
      status: product.status
    });
    setIsModalOpen(true);
  };

  // ATENÇÃO: Esta é a versão da função handleSaveProduct que espera 'type'
  const handleSaveProduct = async (productData: {
    id?: number;
    name: string;
    family: string;
    type: string; // <--- CUIDADO: Espera 'type', não 'groupName'
    colors: string[];
    gradValues: number[];
    pricing: string;
    status?: boolean;
  }) => {
    try {
      const rawPrice = productData.pricing ? parseFloat(productData.pricing.replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) : 0;

      const payload: ProductPayloadType = {
        name: productData.name,
        family: productData.family,
        type: productData.type, // <--- CUIDADO: Mapeia 'type' de volta para 'type'
        colors: productData.colors,
        size: productData.gradValues,
        price: rawPrice,
        status: productData.id
          ? allProducts.find(p => p.id === productData.id)?.status || true
          : true,
      };

      let url = `http://localhost:8080/fashion-product`;
      let method = 'POST';

      if (productData.id) {
        url = `${url}/${productData.id}`;
        method = 'PUT';
        payload.id = productData.id;
      }

      console.log(`Enviando ${method} para ${url} com payload:`, payload);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro ao ${method === 'POST' ? 'criar' : 'atualizar'} produto! Status: ${response.status}`);
      }

      console.log(`Produto ${method === 'POST' ? 'criado' : 'atualizado'} com sucesso!`);

      // Refetch completo após salvar/atualizar
      setPage(0);
      setAllProducts([]);
      setHasMore(true);
      fetchProducts(0, pageSize, currentProductFilterStatus);

      handleCloseModal(); // Fecha o modal após salvar
    } catch (error: any) {
      console.error("Erro ao salvar produto:", error.message);
      alert(`Erro ao salvar produto: ${error.message}`);
    }
  };


  const handleDelete = (productId: number) => {
    setAllProducts((prev) => prev.filter((product) => product.id !== productId));
  };

  const handlePreviewProduct = (product: ProductType) => {
    setPreviewProduct(product);
    setIsPreviewOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setProductToEdit(null);
  };

  const handleOpenEditModalFromPreview = (product: ProductType) => {
    setIsPreviewOpen(false);
    setPreviewProduct(null);
    handleEdit(product);
  };

  const handleApplyFilter = (status: FilterStatus) => {
    setCurrentProductFilterStatus(status);
    setIsFilterModalOpen(false);
  };

  const handleOpenFilterModal = () => {
    setIsFilterModalOpen(true);
  };

  return (
    <PageContainer> {/* Garanta que PageContainer tenha "position: relative;" ou similar em seu style.ts */}
      <Header>
        <Title>Produtos</Title>
        <ButtonGroup>
          <FilterButton ref={filterButtonRef} onClick={handleOpenFilterModal}>
            <img src={FilterIcon} alt="Filtrar" width={14} height={14} />
            Filtrar
          </FilterButton>

          <NewProductButton
            onClick={() => {
              setProductToEdit(null);
              setIsModalOpen(true);
            }}
          >
            <img src={plusOn} alt="Novo produto" width={18} height={18} />
            Novo produto
          </NewProductButton>
        </ButtonGroup>
      </Header>

      <TableHeaderContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Código</TableCell>
              <TableCell>Produto</TableCell>
              <TableCell>Episódio</TableCell>
              <TableCell>Grupo</TableCell>
              <TableCell>Cores</TableCell>
              <TableCell>Graduação</TableCell>
              <TableCell>Preço</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableHeaderContainer>

      <TableWrapper>
        <Table>
          <tbody>
            {visibleProducts.length > 0 ? (
              visibleProducts.map((product) => (
                <TableRow key={product.id}>
                  <TableCell>
                    <button
                      onClick={() => statusCheck(product.id)}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                    >
                      <img
                        src={checkedProducts[product.id] ? SwitchOnIcon : SwitchOffIcon}
                        alt="Check"
                        width={52} height={32}
                      />
                    </button>
                  </TableCell>
                  <TableCell style={{ color: '#202020' }}>{product.code}</TableCell>
                  <TableCell>{product.name}</TableCell>
                  <TableCell>{product.family}</TableCell>
                  <TableCell>{product.type}</TableCell>
                  <TableCell>{product.colors}</TableCell>
                  <TableCell>{product.graduation}</TableCell>
                  <TableCell>{product.price}</TableCell>
                  <TableCell>
                    <Actions>
                      <ActionButton onClick={() => handlePreviewProduct(product)}>
                        <img src={SearchIcon} alt="Visualizar" width={24} height={24} />
                      </ActionButton>
                    </Actions>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={9} style={{ textAlign: 'center', padding: '20px' }}>
                  Nenhum produto encontrado com o filtro atual.
                </TableCell>
              </TableRow>
            )}
          </tbody>
        </Table>
      </TableWrapper>

      {hasMore && currentProductFilterStatus === 'all' && (
        <LoadMoreButton onClick={handleLoadMore}>
          <img src={ArrowDownIcon} alt="Carregar mais" width={18} height={18} />
          Carregar mais
        </LoadMoreButton>
      )}

      <NewProductModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        productToEdit={productToEdit}
        onSave={handleSaveProduct} // <--- ATENÇÃO: Aqui o erro TS2322 pode voltar
      />

      <ProductPreviewModal
        isOpen={isPreviewOpen}
        onClose={() => setIsPreviewOpen(false)}
        product={previewProduct}
        onEdit={handleOpenEditModalFromPreview}
      />

      <ProductsFilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        onApplyFilter={handleApplyFilter}
        currentFilterStatus={currentProductFilterStatus}
        top={filterButtonPosition.top}
        left={filterButtonPosition.left}
        width={filterButtonPosition.width}
      />
    </PageContainer>
  );
};

export default ProductsPage;